module.exports = __webpack_public_path__ + "static/media/location-pin-svgrepo-com.d9fd9245.svg";